
import BaseBlock from '@headlines/utils/BaseBlock';
import ContentFragment from '@core/components/ContentFragment.vue';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType116';

const defaultSettings = {
  config: [
    {
      blockTitle: '',
      blockHtml: '',
      isActive: false,
    },
  ],
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    ContentFragment,
  },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  methods: {
    setActiveTab(index: string | number): void {
      this.activeTabIndex = Number(index);
      this.trackActiveTabView();
    },
    trackActiveTabView(): void {
      const activeTab = this.data?.config?.[this.activeTabIndex];
      if (!activeTab) {
        return;
      }

      this?.$event?.send('tabbed_html_widget_views', {
        active_tab: activeTab.blockTitle,
      });
    },
    getTabContent(blockHtml: string) {
      return {
        type: 'embed',
        html: '',
        attrs: {
          type: 'custom',
          code: blockHtml,
        },
      };
    },
  },
  mounted() {
    if (this.data.config && this.data.config.length > 0) {
      const activeIndex = this.data.config.findIndex((item: { isActive: boolean }) => item.isActive === true);
      if (activeIndex !== -1) {
        this.activeTabIndex = activeIndex;
      }

      this.trackActiveTabView();
    }
  },
});
